/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createAxiosInstance } from '@next-common/redux-apollo-helper';
import { loadEshopHeaderData, isEshopNavAndSearch, isNotCanopyFn, setKw } from './actions';
export const initialAction = (watchContext, baseUrl = '', preloadedConfig) => (dispatch) => {
    var _a, _b, _c;
    const promises = [];
    const eshopNavAndSearch = ((_a = preloadedConfig.EshopHeader) === null || _a === void 0 ? void 0 : _a.isEshopNavAndSearch) !== undefined ? (_b = preloadedConfig.EshopHeader) === null || _b === void 0 ? void 0 : _b.isEshopNavAndSearch : undefined;
    const isNotCanopy = ((_c = preloadedConfig.EshopHeader) === null || _c === void 0 ? void 0 : _c.isNotCanopy) !== undefined ? preloadedConfig.EshopHeader.isNotCanopy : null;
    const { eshopSellerLogin, wsBaseUrl, kw } = preloadedConfig.EshopHeader;
    promises.push(dispatch(isNotCanopyFn(isNotCanopy)));
    if (kw) {
        promises.push(dispatch(setKw(kw)));
    }
    const axiosInstance = createAxiosInstance({ context: watchContext, moduleName: 'EshopHeaderModule' });
    if (eshopNavAndSearch !== (null || undefined)) {
        promises.push(dispatch(isEshopNavAndSearch(eshopNavAndSearch)));
        if (eshopNavAndSearch) {
            promises.push(dispatch(loadEshopHeaderData(axiosInstance, eshopSellerLogin, wsBaseUrl)));
            return Promise.all(promises);
        }
        return;
    }
    // load Data when called on nextJs Eshop Landing Desktop & mob + and on pricemobile or monolithe
    promises.push(dispatch(loadEshopHeaderData(axiosInstance, eshopSellerLogin, wsBaseUrl)));
    return Promise.all(promises);
};
